import React, { useRef, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import DynAppBanner from 'src/universal/components/DynamicAppBanner';
import ApplyOrUpgradeCta from 'src/universal/components/ApplyOrUpgradeCta';
import DynamicAppModal from 'src/universal/components/DynamicApp/DynamicAppModal';
import { DynamicAppModalContext } from 'src/universal/components/DynamicApp/redux';
import { getDynAppModalContent } from 'src/universal/components/DynamicApp/redux';
import { getCombinedG163Data } from './redux';
import custStyles from './__styles__/custDynApp.scss?modules';
import styles from './__styles__/index.scss?modules';

const BannerHolder = ({ staticG163Data, currCard, dynAppModalContent }) => {
  const ctaRefFromBanner = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleDynAppModalOpen = useCallback(() => setIsModalOpen(prev => !prev), []);

  return (
    <div className={styles.dynAppBannerOuter}>
      <DynamicAppModalContext.Provider value={toggleDynAppModalOpen}>
        <DynAppBanner
          bannerDataInjected={staticG163Data.dynamicAppBanner}
          custStyles={custStyles}
        />
        <DynamicAppModal
          modal={isModalOpen}
          toggle={toggleDynAppModalOpen}
          content={dynAppModalContent}
          buttonRef={ctaRefFromBanner}
        />
      </DynamicAppModalContext.Provider>
      <ApplyOrUpgradeCta
        shortName={currCard.shortName}
        position={'Banner'}
        makeApplySecondaryCta={true}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...getCombinedG163Data(state),
    dynAppModalContent: getDynAppModalContent(state)
  };
};

export default connect(mapStateToProps)(React.memo(BannerHolder));
